import clsx from 'clsx';
import Link from 'next/link';
import { ComponentProps } from 'react';

import { URL } from '@/config/url';
import { EntityListArticleItem } from '@/shared/api/__generated__/models';
import * as ArticleComponents from '@/shared/ui/Article';
import { formatArticleDate } from '@/shared/utils';
import styles from './TextArticle.module.css';

interface TextArticleProps {
  className?: string;
  article: EntityListArticleItem;
  slots?: {
    titleProps?: ComponentProps<typeof ArticleComponents.ArticleTitle>;
    dateProps?: ComponentProps<typeof ArticleComponents.ArticleDate>;
  };
}

export const TextArticle = ({
  className,
  article,
  slots,
}: TextArticleProps) => {
  return (
    <Link
      className={clsx(styles.article, className)}
      href={URL.article((article.slug || article.id) ?? '')}
    >
      <ArticleComponents.ArticleTitle
        className={styles.title}
        fontSize={16}
        fontWeight={700}
        lineHeight="130%"
        {...slots?.titleProps}
      >
        {article.title}
      </ArticleComponents.ArticleTitle>
      <ArticleComponents.ArticleDate
        fontSize={12}
        fontWeight={500}
        lineHeight="12px"
        {...slots?.dateProps}
      >
        {formatArticleDate(article.publish_date ?? '')}
      </ArticleComponents.ArticleDate>
    </Link>
  );
};
